import './App.css';
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import store from 'store'
// import Loader from '././components/loader';
import AppRouter from '././router/app-router';  
import { Actions as AuthActions } from './redux/auth/reducers'
import ScrollToTop from './components/scroll-to-top';
// import useConnection from '././utils/hook/use-connection';


const App = () => {
  const dispatch = useDispatch();
  
  // Uygulama başlangıcında localStorage'dan userInfo'yu yükle
  useEffect(() => {
    const token = store.get('token');
    const userInfo = store.get('userInfo');
    
    if (token && userInfo) {
      dispatch(AuthActions.setAuthState({
        userInfo: userInfo,
        isUserAuthorized: true
      }));
    }
  }, [dispatch]);

  // const { status, Offline } = useConnection();

  return (
    <>
      {/* {!status && <Offline />} */}
      <div className="App">
        {/* {loaded ? ( */}
        <ScrollToTop />
        <AppRouter />
        {/* ) : (
          // <Loader onLoaded={onLoaded} token={token} />
          <div>Loading....</div>
        )} */}
      </div>
    </>
  );
}

export default App;